import { format } from '@formkit/tempo';
const DATE_FORMAT = 'YYYY-MM-DD';
// формує параметри для generateBcomUrl з даних форми
const generateBcomParamsFromFormData = ({ type, formData, }) => ({
    type,
    dates: {
        checkIn: format(formData.checkIn, DATE_FORMAT),
        checkOut: format(formData.checkOut, DATE_FORMAT),
    },
    adultsCount: formData.adultsCount,
    childrenCount: formData.childrenCount,
    childrenAges: formData.children.map(child => child.age),
});
export default generateBcomParamsFromFormData;
